module.exports = __webpack_public_path__ + "img/smell-4.a1274c15.svg";